import { isString } from 'lodash'
import { sniff } from '@/util'

const closeWebview = function (data = {}, name) {
  const config = {}

  data && (config.data = data)
  // name值为webview的值
  name && (config.name = name)

  const jsonStr = isString(data) ? data : JSON.stringify(config)

  if (sniff.isUboxAndroidApp) {
    if (config.data && config.name) {
      window.app?.closeWebview && window.app?.closeWebview(jsonStr)
    } else {
      window.app?.closeWebview && window.app?.closeWebview()
    }
  } else if (sniff.isUboxIosApp) {
    window?.webkit?.messageHandlers?.closeWebview && window?.webkit?.messageHandlers?.closeWebview.postMessage(jsonStr)
  }
}

export default closeWebview